import React from "react";
import _ from "underscore";
import Decorator from "@evertrue/client-decorator";
import PropTypes from "prop-types";
import ChatContactCard from "./chat-contact-card";
import ChatEtUserCard from "./chat-et-user-card";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";
import { getPoolIdFromRoomName, getETUserIDFromChatKitUser, searchCompare } from "../utils/utils";
import { SearchInput } from "@evertrue/et-components";
import useAllETUsersByIdsResolver from "../hooks/use-all-et-users-by-ids-resolver";
import { useChatCurrentUser } from "../contexts/chat-current-user-context";
import { ChatUserLink } from "./chat-room-link";

const MemberList = ({ currentRoom }) => {
  const [searchText, setSearchText] = React.useState();
  const [unavailableContacts, setUnavailableContacts] = React.useState([]);
  const { searchContacts, oid } = useChatDependencyContext();
  const { allUsersById } = useAllETUsersByIdsResolver();
  const { currentChatUser } = useChatCurrentUser();
  // Users that are already exist (and are available for chat) in the room
  const room_users = currentRoom.users
    ? currentRoom.users
        .flatMap(user => {
          const et_user_id = getETUserIDFromChatKitUser(oid, user.id);
          const etUser = allUsersById[et_user_id];
          if (!etUser) return [];
          return {
            chatUser: user,
            etUser,
          };
        })
        .sort((a, b) => {
          if (!a.etUser.name) return -1;
          return a.etUser.name.localeCompare(b.etUser.name);
        })
    : [];

  // fetch unavailable users
  const pool_id = getPoolIdFromRoomName(oid, currentRoom.name);
  React.useEffect(() => {
    if (pool_id && _.isFunction(searchContacts)) {
      searchContacts({ poolIds: [pool_id], hasNoUser: true }).then(({ items = [] }) => {
        const contacts = items.map(Decorator.Contacts.parse);
        setUnavailableContacts(_.sortBy(contacts, "name"));
      });
    }
  }, [pool_id, searchContacts]);

  // filter users and unavailable contacts if there's search text
  let filtered_users = room_users;
  let filtered_unavailable = unavailableContacts;
  if (searchText) {
    filtered_users = _.filter(room_users, user => searchCompare(user.etUser.name, searchText));
    filtered_unavailable = _.filter(unavailableContacts, contact => searchCompare(contact.name, searchText));
  }
  return (
    <React.Fragment>
      <div className="chatroom-settings--search">
        <SearchInput
          placeholder="Search members..."
          value={searchText}
          onChange={setSearchText}
          className="chatroom-settings--search"
        />
      </div>
      {_.map(filtered_users, user => {
        const et_user_id = user.etUser.id;
        if (user.chatUser.id !== currentChatUser.id) {
          return <ChatUserLink key={et_user_id} userId={et_user_id} />;
        } else {
          return (
            <ChatEtUserCard key={et_user_id} userId={et_user_id} className="chat-room-link">
              (you)
            </ChatEtUserCard>
          );
        }
      })}
      {!_.isEmpty(filtered_unavailable) && <div className="chatroom-settings--unavailable">Unavailable</div>}
      {_.map(filtered_unavailable, contact => {
        return (
          <ChatContactCard
            key={contact.id}
            className="chat-room-link chat-room-settings--unavailable"
            contact={contact}
          />
        );
      })}
    </React.Fragment>
  );
};

MemberList.propTypes = {
  currentRoom: PropTypes.object.isRequired,
};

export default MemberList;
